export class RequisitionPerformanceReportPageController {
    /*@ngInject*/
    constructor() {
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.viewReportBy = this.$stateParams.viewReportBy;
        this.viewReportByLabel = "";
        if (this.viewReportBy == 'internalRecruitment') {
            this.viewReportByLabel = " - By Internal Recruitment";
        }
        else if (this.viewReportBy == 'client') {
            this.viewReportByLabel = " - By Client";
        }
        else if (this.viewReportBy == 'vendor') {
            this.viewReportByLabel = " - By Vendor";
        }
    }
}
// import * as TEMPLATE from './requisition-performance-report-page.html';
import * as TEMPLATE from 'raw-loader!./requisition-performance-report-page.html';
export const RequisitionPerformanceReportPageComponent = {
    selector: 'requisitionPerformanceReportPageModule',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/reports/requisitionPerformanceReport/requisition-performance-report-page.html',
        controller: RequisitionPerformanceReportPageController
    }
};
//# sourceMappingURL=requisition-performance-report-page.component.js.map